import { useEffect, useReducer } from "react"
import { lockedReducer } from "../../../utils/defaultReducer"
import { Dialog, DialogTitle, Button, Divider, DialogContent, Box } from "@mui/material"
import Loading from "../../Loading"
import api from "../../../api"
import useNotification from "../../Notification"
import CloseIcon from "@mui/icons-material/Close"
import { DataGridPro, ptBR } from '@mui/x-data-grid-pro'
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { ptBR as corePtBR } from '@mui/material/locale';
import { getNotificationColumns } from "../TabTables/NotificationTable"
import { CustomToolbar } from "../TabTables/NotificationTable"

const theme = createTheme({
    palette: {
        primary: { main: '#21446C' },
    },
}, ptBR, corePtBR);

const processFilters = (filterModel, sortModel) => {
    let filterString = filterModel.items.map(each => {
        if (each.value)
            return (`&${each.columnField}__${each.operatorValue}=${each.value}`)
    }).join('')

    if ('linkOperator' in filterModel && filterModel.linkOperator == 'or')
        filterString += '&or=True'

    const sortString = sortModel.map(each => (`&sort=${each.field}__${each.sort}`)).join('')

    return filterString+sortString
}

const getData = async (task, state, limit, offset, setState) => {
    setState({ loading: true })

    const filterString = processFilters(state.filterModel, state.sortModel)

    const res = await api.get(`/api/enterprises/${task.enterprise}/notifications/?task=${task.id}&limit=${limit}&offset=${offset}${filterString}`)
    const result = { loading: false }
    if (res.status === 200) {
        result.rows = res.data.results
        result.offset = offset
        result.count = res.data.count
        result.limit = limit
        result.filterModel = state.filterModel
        result.sortModel = state.sortModel
    } else {
        useNotification(
            "Ops!",
            'Dados não foram encontrados',
            'danger'
        )
    }

    setState(result)
}

const EventsNotifications = ({ task, handleClose }) => {

    const [state, setState] = useReducer(lockedReducer, {
        rows: [],
        offset: 0,
        count: 0,
        limit: 25,
        loading: false,
        filterModel: {items: []},
        sortModel: []

    })

    useEffect(() => {
        getData(task, state, 25, 0, setState)
    }, [])

    return (
        <>
            <Loading loading={state.loading} />
            <Dialog
                open={true}
                keepMounted
                onClose={() => { }}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
                disablePortal
                disableEnforceFocus
                sx={{ position: 'absolute' }}
                fullWidth
                maxWidth='lg'
                className='event-notification-dialog'
            >
                <DialogTitle className={'group-flexbox'}>
                    <span>Notificações do evento {task.name}</span> <Button sx={{ 'minWidth': '2rem', 'padding': '0' }} onClick={handleClose} ><CloseIcon /></Button>
                </DialogTitle>
                <Divider />
                <DialogContent>
                    <Box sx={{ width: '100%', height: '100%' }} >
                        <ThemeProvider theme={theme}>
                            <DataGridPro
                                columns={getNotificationColumns(false, null)}
                                rows={state.rows}
                                disableSelectionOnClick
                                //checkboxSelection={(userGroups.isAdmin || userGroups.isSupervisor || getSession().profile.change_campaigns)}
                                // onSelectionModelChange={(selection) => {
                                //     setSelectedNotifications(selection);
                                // }}
                                //isRowSelectable={(params) => params.row.status !== "SUCCESS"}
                                //selectionModel={selectedNotifications}
                                
                                //keepNonExistentRowsSelected

                                components={{ Toolbar: () => CustomToolbar(null, null) }}
                                density={'compact'}
                                pagination
                                paginationMode="server"
                                rowsPerPageOptions={[25, 50, 100]}
                                page={Math.floor(state.offset/state.limit)}
                                onPageSizeChange={(size) => {getData(task, state, size, state.offset, setState)} }
                                pageSize={state.limit}
                                rowCount={state.count}

                                onPageChange={(newpage) => {getData(task, state, state.limit, newpage*state.limit, setState)}}
                                
                                initialState={{
                                    pagination: {
                                        pageSize: Number(state.limit)
                                    }
                                }}

                                // //filter
                                filterMode='server'
                                onFilterModelChange={(model)=> {state.filterModel = model ; getData(task, state, state.limit, state.offset, setState)}}
                                filterModel={state.filterModel}

                                // //sorting
                                sortingMode="server"
                                onSortModelChange={(model)=>{state.sortModel = model ;  getData(task, state, state.limit, state.offset, setState)}}
                                sortModel={state.sortModel}
                            />
                        </ThemeProvider>
                    </Box>
                </DialogContent>
            </Dialog>
        </>
    )
}

export default EventsNotifications